import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '~/lib/format-date';
import { formatCurrency } from '~/lib/dashboard/format';
import { BUNDLE_TYPE } from '~/lib/bundles';

/** Translates a bundle reason / row warning code (unknown codes fall back to the code itself). */
export function useBundleCodeLabel() {
	const { t } = useTranslation();
	return useMemo(
		() => ({
			reason: (code: string) => t(`catalog.bundles.reasons.${code}`, { defaultValue: code }),
			warning: (code: string) => t(`catalog.bundles.warnings.${code}`, { defaultValue: code }),
			type: (ptype?: number) => (ptype === BUNDLE_TYPE ? t('catalog.bundles.types.bundle') : t('catalog.bundles.types.giftbox'))
		}),
		[t]
	);
}

export const money = (n?: number | null) => (n == null ? '—' : formatCurrency(n));

export function formatActiveWindow(from?: unknown, to?: unknown): string {
	const f = from ? formatDateTime(String(from)) : null;
	const tt = to ? formatDateTime(String(to)) : null;
	if (!f && !tt) return '—';
	return `${f ?? '…'} → ${tt ?? '…'}`;
}
